import { createReducer, on } from '@ngrx/store';

import { loadSurveyTemplatesSuccess } from '@main-application/survey-creator/actions/surveys.actions';
import { RestSurveyTemplate } from '@main-application/survey-creator/interfaces/survey-template';

export const surveysFeatureKey = 'surveys';

export interface State {
  surveyTemplates: RestSurveyTemplate[];
}

export const initialState: State = {
  surveyTemplates: [],
};

export const reducer = createReducer(
  initialState,
  on(loadSurveyTemplatesSuccess, (state, action) => ({
    ...state,
    surveyTemplates: action.templates,
  }))
);
